import React, { createContext, useState } from "react";

export const Context = createContext();

const ContextProvider = ({ children }) => {
  const [theme, setTheme] = useState(false);
  const [active, setActive] = useState("Home");

  // ===============================
  // 📌  SCROLL FUNCTIONS (INCLUDED)
  // ===============================
  const scrollToAbout = () => {
    const section = document.getElementById("about");
    if (section) {
      window.scrollTo({ top: section.offsetTop, behavior: "smooth" });
    }
  };

  const scrollToHome = () => {
    const section = document.getElementById("home");
    if (section) {
      window.scrollTo({ top: section.offsetTop, behavior: "smooth" });
    }
  };

  const scrollToProjects = () => {
    const section = document.getElementById("projects");
    if (section) {
      window.scrollTo({ top: section.offsetTop, behavior: "smooth" });
    }
  };

  const scrollToContact = () => {
    const section = document.getElementById("contact");
    if (section) {
      window.scrollTo({ top: section.offsetTop, behavior: "smooth" });
    }
  };

//   const pastProjects= [
//       {id:5, title: "INFRASTRUCTURAL DEVELOPMENT PROJECT", file: require("../PROJECTS/Infrastructural Development Project_Melegun Town.pdf") },
//       {id:2, title: "5 HECTARE PLANT DEVELOPMENT", file: require("../PROJECTS/5HECTARE PLANT DEVELOPMENT_CIVIL_STRUCTURAL DRAWINGS.pdf") },
//       {id:6, title: "RESIDENTIAL DEVELOPMENT", file: require("../PROJECTS/RESIDENTIAL DEVELOPMENT.pdf") },
//      {id:3, title: "AHU PLATFORM", file: require("../PROJECTS/AHU PLATFORM.pdf") },
//      {id:4, title: "CONCRETE WORK EXTENSION", file: require("../PROJECTS/CONCRETE WORK EXTENSION_WAREHOUSE.pdf") },
     
//       {id:1, title: "SCAN TO BIM SAMPLE PROJECT", file: require("../PROJECTS/SCAN TO BIM SAMPLE PROJECT.pdf") },
//         {id:7,
//          title: "COVER LETTER",
//          file: require("../Images/CHINEDU JOSEPH NDU COVER LETTER 2023.pdf"),
//        },
//          {id:8,
//         title: "CREDENTIALS",
//         file: require("../Images/Credentials_Chinedu Joseph Ndu .pdf"),
//       },

//     ]





const pastProjects= [
     // Files in the order they appear in the image
     {id:1, title: "4 LANE BRIDGE MODEL AND COORDINATION", file: "https://drive.google.com/file/d/1Su_gKpzdtbBpMSTpjDYOBQWkirbIblrA/view?usp=sharing"},
     {id:2, title: "6 HECTARE PLANT DEVELOPMENT", file: "https://drive.google.com/file/d/1HiHbFrYU6fDagE6VZgVQambQTn31YxXf/view?usp=sharing" },
     {id:3, title: "AHU PLATFORM", file:"https://drive.google.com/file/d/1ZsEW_pNVud4nk7G3FfTT_kF2PGdF3LHM/view?usp=sharing" },
     {id:4, title: "CONCRETE WORK EXTENSION", file: "https://drive.google.com/file/d/16a2MGk1iykVlXyPGTtbuqfUoxDWygHAA/view?usp=sharing" },
     {id:5, title: "FLOOD CONTROL", file: "https://drive.google.com/file/d/1Q2koHR2CDdhgSAm1xKEfG4iFtGu-KUlK/view?usp=sharing" },
     {id:6, title: "INFRASTRUCTURAL DEVELOPMENT PROJECT", file: "https://drive.google.com/file/d/1rzMCuumy8B46w2mW-ZPKi5_t-_zqIDpX/view?usp=sharing" },
     // Skipping ID 7 and 8 to match the original structure's commented items
     {id:9, title: "RESIDENTIAL DEVELOPMENT", file: "https://drive.google.com/file/d/1j1k4P4W0BTw_8mdWp9fYn-U6rYB4esui/view?usp=sharing" },
     {id:10, title: "SCAN TO BIM SAMPLE PROJECT", file: "https://drive.google.com/file/d/1OqsLGeKm2-lB3eskxPtcyOG73nvaZAHR/view?usp=sharing" },
     {id:11, title: "STRUCTURAL OBSERVATION OF HIGH RISE BUILDING", file: "https://drive.google.com/file/d/1n5-QxvdBngEiHBZUdwuZSvSzoY2_aVJs/view?usp=sharing" },
     {id:12, title: "STRUCTURAL PIPE BRIDGE", file: "https://drive.google.com/file/d/1os9rabiyklB12pTOCjLFb6g9wnwI9RCw/view?usp=sharing" },
     {id:13, title: "STRUCTURAL WAREHOUSE", file: "https://drive.google.com/file/d/1ol95DR1FLTwPBuaODPNl5UySnnAyG1-V/view?usp=sharing" },

    // The two original, non-project file items are kept but remain commented out.
{id:7,
title: "COVER LETTER",
file: require("../Images/CHINEDU JOSEPH NDU COVER LETTER 2023.pdf"),
},
{id:8,
 title: "CREDENTIALS",
file: "https://drive.google.com/file/d/1sUNE7J6-FIB8KjIQ3KIpHwX9vwyGcTWL/view?usp=sharing",
},
{
    id:14,
    title: "MY RESUME",
    file: "https://drive.google.com/file/d/1xQZj-SoRIySSPNxlUk7BFviJ8cC9kL7c/view?usp=sharing"
}
]


  // ===============================
  // 📌 ALL PDF FILE GROUPS STORED HERE
  // ===============================
//   const pdfProjects = {
  

//     coverLetter: [
//      
//     ],

//     credentials: [
//     
//     ],
//   };

  // ===============================
  // 📌 Which PDF group is showing now
  // ===============================
const [selectedPdf, setSelectedPdf,] = useState(null)

  return (
    <Context.Provider
      value={{
        theme,
        setTheme,
        active,
        setActive,

        // Scroll functions
        scrollToAbout,
        scrollToHome,
        scrollToProjects,
        scrollToContact,

        // PDF Data
        // pdfProjects,
       selectedPdf, setSelectedPdf,
        pastProjects
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default ContextProvider;
